import DOMPurify from "dompurify";

export const SimpleMarkdown = (text: string, theme: any) => {
  const assureText = "" + text;

  const parsedText = assureText
    .replace(
      /(\*([^*]+)\*)/g, // Match bold
      (match, p1, p2) =>
        p2 ? "<strong>" + p2 + "</strong>" : "<strong>" + p1 + " </strong>"
    )
    .replace(
      /(_([^_]+)_)/g, // Match italics
      (match, p1, p2) => (p2 ? "<em>" + p2 + "</em>" : "<em>" + p1 + " </em>")
    )
    .replace(
      /(~([^~]+)~)/g, // Match Strikethrough
      (match, p1, p2) => (p2 ? "<s>" + p2 + "</s>" : "<s>" + p1 + " </s>")
    )
    .replace(
      /\$r\$\s*([\s\S]*?)\s*\$r\$/g, // Match Color Red
      (match, p1) =>
        `<span style='color:${theme.palette.error.main}'>` + p1 + "</span>"
    )
    .replace(
      /\$g\$\s*([\s\S]*?)\s*\$g\$/g, // Match Color Green
      (match, p1) =>
        `<span style='color:${theme.palette.primary.main}'>` + p1 + "</span>"
    )
    .replace(
      /\$b\$\s*([\s\S]*?)\s*\$b\$/g, // Match Color Blue
      (match, p1) =>
        `<span style='color:${theme.palette.status.status1}'>` + p1 + "</span>"
    );

  const cleanText = DOMPurify.sanitize(parsedText, {
    USE_PROFILES: { html: true },
  });

  return { __html: cleanText };
};
